module.exports = __webpack_public_path__ + "img/reload-icon.66d82e1a.svg";